import { red } from '@mui/material/colors';

export const theme = {
  palette: {
    primary: {
      main: '#006064',
    },
    secondary: {
      main: '#ffc400',
    },
    error: {
      main: '#ff1744',
    },
  },
};
